import React from 'react';
import { FacebookIcon, WrenchIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-dark border-t border-brand-border py-12" data-id="element-47">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-48">
        <div className="flex items-center gap-3" data-id="element-49">
          <WrenchIcon className="w-5 h-5 text-brand-accent" data-id="element-50" />
          <span className="font-heading font-bold text-lg tracking-industrial text-brand-white uppercase" data-id="element-51">
            Ionuț Drăgănescu
          </span>
        </div>

        <div className="flex items-center gap-6" data-id="element-52">
          <a href="https://www.facebook.com/p/Ionut-Draganescu-Business-Coach-61559171806988/" target="_blank" rel="noopener noreferrer" className="text-brand-muted hover:text-brand-accent transition-colors" aria-label="Facebook" data-id="element-53">
            <FacebookIcon className="w-6 h-6" data-id="element-54" />
          </a>
        </div>

        <div className="text-brand-dim font-body text-sm" data-id="element-55">
          &copy; {currentYear} Ionuț Drăgănescu. Toate drepturile rezervate.
        </div>
      </div>
    </footer>;
}